"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSFORM_SETTINGS = exports.DEFAULT_SETTINGS = exports.HEIGHT = exports.WIDTH = void 0;
var WIDTH = 400;
exports.WIDTH = WIDTH;
var HEIGHT = 500;
exports.HEIGHT = HEIGHT;
var DEFAULT_SETTINGS = {
  rect: {
    type: 'rect',
    width: 100,
    height: 100,
    fill: '#2460A7',
    stroke: 'rgba(0, 0, 0, 0)',
    strokeWidth: 0,
    rotation: 0
  },
  circle: {
    type: 'circle',
    width: 100,
    height: 100,
    fill: 'rgba(106, 174, 170, 1)',
    stroke: 'rgba(0, 0, 0, 0)',
    strokeWidth: 0,
    rotation: 0
  },
  curve: {
    type: 'curve',
    width: 100,
    height: 100,
    fill: '#949CD0',
    stroke: '#491D70',
    strokeWidth: 1,
    rotation: 0,
    anchors: true,
    close: true
  },
  text: {
    type: 'text',
    fill: '#000000',
    stroke: 'rgba(0, 0, 0, 0)',
    strokeWidth: 0,
    text: 'Текст',
    rotation: 0,
    fontSize: 20,
    align: 'left',
    fontStyle: 'normal',
    fontFamily: 'Arial, sans-serif'
  },
  image: {
    type: 'image',
    rotation: 0,
    width: 150,
    height: 150
  },
  qr: {
    type: 'qr',
    fill: '#ffffff',
    width: 150,
    height: 150,
    rotation: 0
  }
};
exports.DEFAULT_SETTINGS = DEFAULT_SETTINGS;
var TRANSFORM_SETTINGS = {
  curve: {
    resizeEnabled: false,
    rotateEnabled: false
  },
  text: {
    resizeEnabled: false
  },
  image: {
    enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
  },
  qr: {
    enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
  }
};
exports.TRANSFORM_SETTINGS = TRANSFORM_SETTINGS;